import React, { useEffect, useState } from 'react'
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { Box, Button, Collapse, Paper, Table, TableBody, TableHead, Typography, Tabs, Tab, Container, Card, CardContent, Grid } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getUserDetails } from '../../redux/userRelated/userHandle';
import { calculateOverallAttendancePercentage, calculateSubjectAttendancePercentage, groupAttendanceBySubject } from '../../components/attendanceCalculator';

import CustomBarChart from '../../components/CustomBarChart'

import InsertChartIcon from '@mui/icons-material/InsertChart';
import InsertChartOutlinedIcon from '@mui/icons-material/InsertChartOutlined';
import TableChartIcon from '@mui/icons-material/TableChart';
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';
import { StyledTableCell, StyledTableRow } from '../../components/styles';

const ViewStdAttendance = () => {
    const dispatch = useDispatch();

    const [openStates, setOpenStates] = useState({});

    const handleOpen = (subId) => {
        setOpenStates((prevState) => ({
            ...prevState,
            [subId]: !prevState[subId],
        }));
    };

    const { userDetails, currentUser, loading, response, error } = useSelector((state) => state.user);

    useEffect(() => {
        dispatch(getUserDetails(currentUser._id, "Student"));
    }, [dispatch, currentUser._id]);

    if (response) { console.log(response) }
    else if (error) { console.log(error) }

    const [subjectAttendance, setSubjectAttendance] = useState([]);
    const [selectedSection, setSelectedSection] = useState('table');

    useEffect(() => {
        if (userDetails) {
            setSubjectAttendance(userDetails.attendance || []);
        }
    }, [userDetails])

    const attendanceBySubject = groupAttendanceBySubject(subjectAttendance)

    const overallAttendancePercentage = calculateOverallAttendancePercentage(subjectAttendance);

    const subjectData = Object.entries(attendanceBySubject).map(([subName, { subCode, present, sessions }]) => {
        const subjectAttendancePercentage = calculateSubjectAttendancePercentage(present, sessions);
        return {
            subject: subName,
            attendancePercentage: subjectAttendancePercentage,
            totalClasses: sessions,
            attendedClasses: present
        };
    });

    const handleSectionChange = (event, newSection) => {
        setSelectedSection(newSection);
    };

    const renderTableSection = () => {
        return (
            <>
                <Grid container spacing={3} mb={4}>
                    <Grid item xs={12} md={4}>
                        <Card sx={{ bgcolor: '#e0f2fe', borderRadius: '16px', boxShadow: 'none' }}>
                            <CardContent sx={{ textAlign: 'center', py: 3 }}>
                                <Typography variant="subtitle1" color="#0369a1" fontWeight="600" gutterBottom>
                                    Overall Attendance
                                </Typography>
                                <Typography variant="h3" color="#0284c7" fontWeight="800">
                                    {overallAttendancePercentage.toFixed(2)}%
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>

                <Card sx={{ borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
                    <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
                        <Box sx={{ p: 3, pb: 1 }}>
                            <Typography variant="h5" fontWeight="700" color="#1e293b">
                                Subject-wise Details
                            </Typography>
                        </Box>
                        <Table sx={{ minWidth: 650 }}>
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell sx={{ borderBottom: '2px solid #f1f5f9' }}>Subject</StyledTableCell>
                                    <StyledTableCell sx={{ borderBottom: '2px solid #f1f5f9' }}>Present</StyledTableCell>
                                    <StyledTableCell sx={{ borderBottom: '2px solid #f1f5f9' }}>Total Sessions</StyledTableCell>
                                    <StyledTableCell sx={{ borderBottom: '2px solid #f1f5f9' }}>Attendance Percentage</StyledTableCell>
                                    <StyledTableCell align="center" sx={{ borderBottom: '2px solid #f1f5f9' }}>Actions</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            {Object.entries(attendanceBySubject).map(([subName, { present, allData, subId, sessions }], index) => {
                                const subjectAttendancePercentage = calculateSubjectAttendancePercentage(present, sessions);

                                return (
                                    <TableBody key={index}>
                                        <StyledTableRow sx={{ '&:hover': { backgroundColor: 'rgba(241, 245, 249, 0.5)' } }}>
                                            <StyledTableCell sx={{ fontWeight: 600, color: '#334155', borderBottom: '1px solid #f1f5f9' }}>{subName}</StyledTableCell>
                                            <StyledTableCell sx={{ borderBottom: '1px solid #f1f5f9' }}>{present}</StyledTableCell>
                                            <StyledTableCell sx={{ borderBottom: '1px solid #f1f5f9' }}>{sessions}</StyledTableCell>
                                            <StyledTableCell sx={{ fontWeight: 600, color: subjectAttendancePercentage < 75 ? '#ef4444' : '#10b981', borderBottom: '1px solid #f1f5f9' }}>
                                                {subjectAttendancePercentage}%
                                            </StyledTableCell>
                                            <StyledTableCell align="center" sx={{ borderBottom: '1px solid #f1f5f9' }}>
                                                <Button variant="outlined" sx={{ borderRadius: '20px', textTransform: 'none' }}
                                                    onClick={() => handleOpen(subId)}>
                                                    {openStates[subId] ? <KeyboardArrowUp /> : <KeyboardArrowDown />} Details
                                                </Button>
                                            </StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                            <StyledTableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                                                <Collapse in={openStates[subId]} timeout="auto" unmountOnExit>
                                                    <Box sx={{ margin: 2, p: 2, bgcolor: '#f8fafc', borderRadius: '12px' }}>
                                                        <Typography variant="subtitle1" fontWeight="600" gutterBottom component="div" color="#475569">
                                                            Session History
                                                        </Typography>
                                                        <Table size="small" aria-label="purchases">
                                                            <TableHead>
                                                                <StyledTableRow>
                                                                    <StyledTableCell sx={{ color: '#64748b', bgcolor: 'transparent' }}>Date</StyledTableCell>
                                                                    <StyledTableCell align="right" sx={{ color: '#64748b', bgcolor: 'transparent' }}>Status</StyledTableCell>
                                                                </StyledTableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {allData.map((data, index) => {
                                                                    const date = new Date(data.date);
                                                                    const dateString = date.toString() !== "Invalid Date" ? date.toISOString().substring(0, 10) : "Invalid Date";
                                                                    return (
                                                                        <StyledTableRow key={index} sx={{ bgcolor: 'transparent' }}>
                                                                            <StyledTableCell component="th" scope="row" sx={{ borderBottom: '1px solid #e2e8f0', color: '#334155' }}>
                                                                                {dateString}
                                                                            </StyledTableCell>
                                                                            <StyledTableCell align="right" sx={{ borderBottom: '1px solid #e2e8f0', color: data.status === 'Present' ? '#10b981' : '#ef4444', fontWeight: 600 }}>
                                                                                {data.status}
                                                                            </StyledTableCell>
                                                                        </StyledTableRow>
                                                                    )
                                                                })}
                                                            </TableBody>
                                                        </Table>
                                                    </Box>
                                                </Collapse>
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    </TableBody>
                                )
                            })}
                        </Table>
                    </CardContent>
                </Card>
            </>
        )
    }

    const renderChartSection = () => {
        return (
            <>
                <CustomBarChart chartData={subjectData} dataKey="attendancePercentage" />
            </>
        )
    };

    return (
        <>
            {loading
                ? (
                    <div>Loading...</div>
                )
                :
                <div>
                    {subjectAttendance && Array.isArray(subjectAttendance) && subjectAttendance.length > 0 ?
                        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                                <Tabs 
                                    value={selectedSection} 
                                    onChange={handleSectionChange} 
                                    textColor="primary"
                                    indicatorColor="primary"
                                    sx={{
                                        '& .MuiTab-root': { fontWeight: 600, textTransform: 'none', fontSize: '1rem' }
                                    }}
                                >
                                    <Tab label="Table View" value="table" icon={<TableChartIcon sx={{ mr: 1 }} />} iconPosition="start" />
                                    <Tab label="Chart View" value="chart" icon={<InsertChartIcon sx={{ mr: 1 }} />} iconPosition="start" />
                                </Tabs>
                            </Box>

                            {selectedSection === 'table' && renderTableSection()}
                            {selectedSection === 'chart' && (
                                <Card sx={{ mt: 3, borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)', p: 3 }}>
                                    {renderChartSection()}
                                </Card>
                            )}
                        </Container>
                        :
                        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
                            <Card sx={{ p: 4, textAlign: 'center', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
                                <Typography variant="h6" color="text.secondary">
                                    Currently You Have No Attendance Details
                                </Typography>
                            </Card>
                        </Container>
                    }
                </div>
            }
        </>
    )
}

export default ViewStdAttendance